import $ from 'jquery';

export default function sortOnChange() {
  $('.js-sort').on('change', function(event) {
    event.target.closest('form').submit();
  })
}